/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
export default function simulateClick (elem:HTMLElement): void {
	// Create our event (with options)
	const evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	!elem.dispatchEvent(evt);
}